import React from "react";
import phones from "../images/phones-color.svg";
import logo from "../images/main-logo.png";
import {ROLE_AGENT, ROLE_CUSTOMER} from "../utils/constants";
import {
    getBackToIntentHistoryMessage,
    updateLastIntentHistory
} from "./IntentsHistory";
import {BackIcon} from "./Icons";
import {keydownHandler} from "../utils/commonHelper";

const Message = (props) => {
    const {data, message, role, isLastInChain, isLastMessageForRole, avatar, dataKey} = props;

    if ((data !== null && data.title === undefined) && message === undefined) {
        return;
    }

    const formatText = (text) => {
        const urlPattern = /(^|\s)(?:https?|ftp):\/\/[a-z0-9-+&@#\/%?=~_|!:,.;]*[a-z0-9-+&@#\/%=~_|]/gim;
        text = text.replace(urlPattern, '<a target="_blank" href="$&">$&</a>');
        if(text.includes('\n')){
            text = text.replace(/\n/g,'<br>')
        }
        return text
    }

    return <div className={"message-box " + role} key={'mss_' + dataKey}>
        {
            role !== ROLE_CUSTOMER && <div className={"avatar" + (isLastInChain ? " message__last" : "")}>
                <img className={"u291_img " + (role === ROLE_AGENT ? "phones" : "")} width={16} height={26}
                     src={avatar ? avatar : (role === ROLE_AGENT ? phones : logo)}/>
            </div>
        }
        {
            role === ROLE_CUSTOMER && isLastMessageForRole && <>
                <a className="go_back_button noselect"
                   tabIndex={0}
                   onKeyDown={keydownHandler}
                   onClick={(e) => {
                       e.preventDefault();
                       if (e.currentTarget) {
                           if (e.currentTarget.disabled) {
                               return;
                           }
                           e.currentTarget.style.display = "none";
                           e.currentTarget.disabled = true;
                       }
                       let message;
                       try {
                           message = getBackToIntentHistoryMessage();
                           if (!message) {
                               return;
                           } else {
                               updateLastIntentHistory(null);
                           }
                       } catch (e) {
                           console.error(e)
                       }
                       props.sendMessage(message);
                   }}
                >
                    <div style={{display: "flex"}}>
                        <BackIcon className="icon_back"/>
                        <span>Back</span>
                    </div>
                </a>
            </>
        }
        <div className={"message " + role + (isLastInChain ? " message__last" : "")}>
            <div dangerouslySetInnerHTML={{__html: data && data.title ? formatText(data.title) : formatText(message)}}/>
        </div>
    </div>
}

export default Message;
